import React from 'react';
import { ModuleBridge } from '../components';

export const MigrationSetup = () => {
    return <ModuleBridge moduleId="migration_setup_module" />;
};
